import { Location, Township } from "../Models";
import HotelSearchCriteria, { GuestType } from "./HotelSearchCriteria";

class HotelSearchFormState {
    location: Location;
    numberOfRooms: number = 1;
    guestType: GuestType;
    checkInDate: string;
    checkOutDate: string;

    selectedTownship:Township|null = null;
    selectedPromotion = false
    selectedPriceOrderType = null
    selectableLocations:any[] = [];
    selectableRegions = [];    
    
    isValid() {
        return this.location != null && this.checkInDate != null && this.checkOutDate != null && this.numberOfRooms > 0 && this.guestType != null;        
    }

    toHotelSearchCriteria():HotelSearchCriteria {
        return new HotelSearchCriteria(this.location, this.checkInDate, this.checkOutDate, this.numberOfRooms, this.guestType); 
    }
}

export default HotelSearchFormState;